import { render, staticRenderFns } from "./dialog-emit.vue?vue&type=template&id=2b0bacd5&scoped=true&"
import script from "./dialog-emit.vue?vue&type=script&lang=js&"
export * from "./dialog-emit.vue?vue&type=script&lang=js&"
import style0 from "./dialog-emit.vue?vue&type=style&index=0&id=2b0bacd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bacd5",
  null
  
)

export default component.exports